import notificationCatalog from '@/i18n/en/notifications.json';

const messageToKey = Object.entries(notificationCatalog).reduce((acc, [key, message]) => {
  acc[message] = `notifications.${key}`;
  return acc;
}, {});

export function resolveNotificationKey(message) {
  if (!message || typeof message !== 'string') return null;
  return messageToKey[message] || null;
}

// duration (ms) is optional, NotificationMessage falls back to its default
export function buildNotificationPayload({ type, message, messageKey, messageParams, duration }) {
  if (messageKey) {
    return { type, messageKey, messageParams: messageParams || {}, duration };
  }
  const resolvedKey = resolveNotificationKey(message);
  if (resolvedKey) {
    return { type, messageKey: resolvedKey, messageParams: messageParams || {}, duration };
  }
  return { type, message, duration };
}

export function dispatchNotification(store, payload) {
  return store.dispatch('notifications/addNotification', buildNotificationPayload(payload), { root: true });
}
